const HTTP_SUCCESS_CODE = 200 // http 请求成功
const HTTP_SERVICE_SYSTEM_TOKEN_OVERDUE = 401 // token 过期
const HTTP_SERVICE_SYSTEM_TOKEN_OVERDUE_STRING = '401' // token 过期
const HTTP_SERVICE_SYSTEM_SUCCESS = '0' // 成功-业务

export default {
  HTTP_SUCCESS_CODE,
  HTTP_SERVICE_SYSTEM_TOKEN_OVERDUE,
  HTTP_SERVICE_SYSTEM_SUCCESS,
  HTTP_SERVICE_SYSTEM_TOKEN_OVERDUE_STRING
}

